import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { ButtonBarEl } from "common/components/button-bar";
import { ButtonBarTheme } from "common/components/button-bar/types";
import { DropMenuEl } from "common/components/drop-menu";
import { InputEl } from "common/components/input";
import { InputGroupEl } from "common/components/input-group";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { SpinnerEl } from "common/components/spinner";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
const SearchableText = ({
  value,
  placeholder,
  searchTokens
}) => !value ? /* @__PURE__ */ jsx("i", null, placeholder) : searchTokens ? /* @__PURE__ */ jsx(null, null, searchTokens.map((token, pos) => pos % 2 === 1 ? token : /* @__PURE__ */ jsx("b", null, token))) : /* @__PURE__ */ jsx(null, null, value);
export function template() {
  const {
    activeItem,
    busy,
    controller,
    creating,
    disableCreateDashboard,
    newTitle,
    open,
    searchFilter,
    sections
  } = this.state;
  const disabledTooltip = (item) => {
    if (this.helpers.isDashboardDisabled(item)) {
      const tooltipTextMissingAccess = this.helpers.isSharingEnabled() ? `editor` : `edit`;
      return /* @__PURE__ */ jsx(TooltipEl, {
        attrs: { placement: Placement.Top }
      }, `You don't have ${tooltipTextMissingAccess} access on this board`);
    }
    return null;
  };
  return /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: { open, direction: this.attr(`direction`), offset: this.attr(`offset`) },
    on: { change: this.helpers.handleMenuChange, perfpoint: this.helpers.handlePerfPoint }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-container"
  }, !creating ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-search-container"
  }, /* @__PURE__ */ jsx(InputEl, {
    attrs: {
      icon: `search`,
      placeholder: this.attr(`search-placeholder`)
    },
    on: { input: this.helpers.handleSearchInput },
    props: { value: searchFilter },
    hook: { insert: this.helpers.handleSearchInputInsertHook }
  })), this.helpers.isCrossProjectEnabled() ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-target-project-selector-container"
  }, /* @__PURE__ */ jsx("span", {
    sel: ".mp-dashboard-selector-project-selector-menu-label"
  }, "Project"), /* @__PURE__ */ jsx(SelectEl, {
    attrs: { theme: SelectTheme.MenuFilter, sections: [] }
  })) : null, !(controller == null ? void 0 : controller.getLoaded()) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-loading"
  }, /* @__PURE__ */ jsx(SpinnerEl, null)) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-items-container",
    class: { "mp-dashboard-selector-compact-mode": this.attr(`compact-mode`) }
  }, sections.length === 0 ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-empty-state"
  }, searchFilter ? `No boards found.` : `You do not have any boards yet.`) : sections.map((section, sectionIndex) => /* @__PURE__ */ jsx(null, null, sectionIndex !== 0 ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-divider"
  }) : null, /* @__PURE__ */ jsx("section", null, section.title && /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-section-header"
  }, section.title), section.items.map((item) => /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-item-row-wrapper"
  }, disabledTooltip(item), /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-item-row",
    key: item.dashboard.id,
    class: {
      "mp-dashboard-selector-active": activeItem && activeItem.dashboard.id === item.dashboard.id,
      "mp-dashboard-selector-disabled": this.helpers.isDashboardDisabled(item)
    },
    on: {
      click: this.helpers.getItemActionHandler(item),
      mouseover: this.helpers.getItemMouseOverHandler(item)
    },
    hook: { insert: this.helpers.handleItemRowInsertHook }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-text"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-title",
    attrs: { title: item.dashboard.title },
    class: { "mp-dashboard-selector-placeholder": !item.dashboard.title }
  }, /* @__PURE__ */ jsx(SearchableText, {
    value: item.dashboard.title,
    placeholder: "Untitled board",
    searchTokens: item.titleSearchTokens
  })), /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-sublabel",
    class: {
      "mp-dashboard-selector-placeholder": this.getDashboardSublabel(item.dashboard)
    }
  }, /* @__PURE__ */ jsx(SearchableText, {
    value: this.getDashboardSublabel(item.dashboard),
    placeholder: "No description",
    searchTokens: item.sublabelSearchTokens
  })))))))))), busy ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-busy"
  }, /* @__PURE__ */ jsx(SpinnerEl, null)) : creating ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-create-field"
  }, /* @__PURE__ */ jsx(InputGroupEl, {
    attrs: { placeholder: `New board title`, busy },
    on: {
      input: this.helpers.handleCreateInput,
      submit: this.helpers.handleCreateSubmit
    },
    props: { value: newTitle },
    hook: { insert: this.helpers.handleCreateInputInsertHook }
  })) : this.attr(`quick-create`) ? /* @__PURE__ */ jsx(ButtonBarEl, {
    attrs: { theme: ButtonBarTheme.Secondary },
    on: { click: this.helpers.handleQuickCreateClick }
  }, this.attr(`quick-create-save-dashboard-copy`)) : !disableCreateDashboard ? /* @__PURE__ */ jsx(ButtonBarEl, {
    attrs: { theme: ButtonBarTheme.Secondary },
    on: { click: this.helpers.handleCreateClick }
  }, "Create New Board") : this.attr(`enable-management`) ? /* @__PURE__ */ jsx(ButtonBarEl, {
    attrs: { theme: ButtonBarTheme.Secondary },
    on: { click: this.helpers.handleManageClick }
  }, "Manage Boards") : null)) : /* @__PURE__ */ jsx("div", {
    sel: ".mp-dashboard-selector-new-dashboard-input"
  }, /* @__PURE__ */ jsx(InputEl, {
    attrs: {
      placeholder: this.attr(`search-placeholder`)
    },
    props: { value: `Untitled` },
    on: { input: this.helpers.handleCreateInput },
    hook: { insert: this.helpers.handleCreateInputInsertHook }
  }), /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: !newTitle
    },
    on: {
      click: this.helpers.handleCreateSubmit
    }
  }, "Save"))));
}
